/*!
  * Furillo helpers.js v2.0.0
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
export function extend() {
    // Variables
    var extended = {};
    var deep = false;
    var i = 0;

    // Check if a deep merge
    if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
        deep = arguments[0];
        i++;
    }

    // Merge the object into the extended object
    const merge = function (obj) {
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                // If property is an object, merge properties
                if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                    extended[prop] = extend(extended[prop], obj[prop]);
                } else {
                    extended[prop] = obj[prop];
                }
            }
        }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
        merge(arguments[i]);
    }

    return extended;
}

export function formattedNumber(value, decimals = 2, locale = 'sv-SE') {

    const oNumber = new Intl.NumberFormat(locale, {
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals
    });

    return oNumber.format(value);
}

export function getParent(element, selector) {

    const evaluateParent = function(current) {
        var matchedParent = null;
        current.parentNode.querySelectorAll(selector).forEach(parent => {
            if (parent === current) {
                matchedParent = parent;
                return false;
            }
            return true;
        });
        return matchedParent;
    };
    
    var parent = element.parentNode;
    while (parent !== document) {
        const matchedParent = evaluateParent(parent);
        if (matchedParent != null)
            break;

        parent = parent.parentNode;
    }
    
    return parent;

}

export function getOffsetTop(elem) {
    var offsetTop = 0;
    do {
        if (!isNaN(elem.offsetTop)) {
            offsetTop += elem.offsetTop;
        }
    } while (elem = elem.offsetParent);
    return offsetTop;
}

export function getOffsetLeft(elem) {
    var offsetLeft = 0;
    do {
        if (!isNaN(elem.offsetLeft)) {
            offsetLeft += elem.offsetLeft;
        }
    } while (elem = elem.offsetParent);
    return offsetLeft;
}

export function observeClassChange(node, callback) {
    let lastClassString = node.classList.toString();
    
    const mutationObserver = new MutationObserver((mutationList) => {
        for (const item of mutationList) {
            if (item.attributeName === "class") {
                const classString = node.classList.toString();
                if (classString !== lastClassString) {
                    callback(node, mutationObserver);
                    lastClassString = classString;
                    break;
                }
            }
        }
    });

    mutationObserver.observe(node, { attributes: true });

    return mutationObserver;
}

export function retry(func, name = 'unnamed', timeout = 500, times = 3) {
    let numberOfTries = 0;
    return new Promise((resolve) => {
        const interval = setInterval(async () => {
            numberOfTries++;
            if (numberOfTries === times) {
                console.info('[retry: ' + name + '] Trying operation for the last time (' + times + ').');
                clearInterval(interval);
            }
            try {
                let result = await func();
                clearInterval(interval);
                console.info('[retry: ' + name + '] ' + result + ' after ' + numberOfTries + ' tries (~' + (timeout * numberOfTries) + 'ms).');
                resolve();
            } catch (err) {
                console.info('[retry: ' + name + '] Try number ' + numberOfTries + ' of ' + times + ' was unsuccessful (' + err + ').');
            }
        }, timeout);
    });
}

export function getScript(url, callback) {
    const script = document.createElement('script');
    script.onload = callback;
    script.async = true;
    script.src = url;

    document.body.appendChild(script);
}

export function addOrUpdateQueryParams(url, key, value) {
    url.searchParams.set(key, value);
    return url;
}